import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card custom-shadow rounded-3 bg-white border mb-4 pb-4" }
const _hoisted_2 = { class: "last-child-none" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "flex-shrink-0" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex-grow-1 ms-10" }
const _hoisted_7 = { class: "fs-14 fw-medium mb-0" }
const _hoisted_8 = { class: "fs-12 mb-0" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "fw-medium fs-12 text-primary ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center gap-2 position-relative custom-padding-30\" style=\"top:-5px;\"><h3 class=\"mb-0 fs-18 fw-semibold\">Upcoming Episodes</h3><div class=\"dropdown action-opt right-for-rtl\" style=\"right:-8px;\"><button class=\"btn bg-transparent p-0 text-end\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-vertical\" style=\"stroke:#64748b;\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"clock\"></i> Today </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"pie-chart\"></i> Last 7 Days </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"rotate-cw\"></i> Last Month </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"calendar\"></i> Last 1 Year </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"bar-chart\"></i> All Time </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.episodes, (episode) => {
        return (_openBlock(), _createElementBlock("div", {
          key: episode.id,
          class: "d-flex gap-2 justify-content-between align-items-center border-bottom border-body-bg custom-padding-30 pt-0 child",
          style: {"margin-bottom":"13.5px","padding-bottom":"13.5px"}
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["text-center rounded-circle", episode.iconBgClass]),
                style: {"width":"40px","height":"40px","line-height":"40px"}
              }, [
                _createElementVNode("img", {
                  src: episode.icon,
                  alt: "notice-board-icon"
                }, null, 8, _hoisted_5)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h4", _hoisted_7, _toDisplayString(episode.title), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(episode.author), 1),
              _createElementVNode("div", _hoisted_9, [
                _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-calendar-line text-primary" }, null, -1)),
                _createElementVNode("span", _hoisted_10, _toDisplayString(episode.date), 1)
              ])
            ])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("button", {
            class: "rounded-circle d-inline-block text-center hover-bg for-dark-read text-decoration-none border bg-transparent",
            style: {"width":"43px","height":"43px","line-height":"42px","color":"#b1bbc8"}
          }, [
            _createElementVNode("i", { class: "ri-arrow-right-up-line fs-24" })
          ], -1))
        ]))
      }), 128))
    ])
  ]))
}